import { FaPlus } from "react-icons/fa6";

import { AddGuestButtonProps } from "@models/shared/shared.model";

const AddGuestButton = ({ disabled, label, onClick }: AddGuestButtonProps) => {
  return (
    <button
      type="button"
      data-testid="add-guest-button"
      className={`text-center align-self-start bg-transparent border-0 fg-profile-card-circle-plus-wrapper ${
        disabled ? "disabled" : ""
      }`}
      onClick={onClick}
      disabled={disabled}
    >
      <div className="rounded-circle border border-2 d-flex align-items-center justify-content-center fg-profile-card-circle-plus">
        <FaPlus data-testid="icon" />
      </div>
      <div className="mt-2">
        <span className="text-decoration-none fg-profile-card-circle-text">
          {label}
        </span>
      </div>
    </button>
  );
};

export default AddGuestButton;
